module.exports = __webpack_public_path__ + "static/img/3.f4748a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/3.png
// module id = yNLR
// module chunks = 0